import { turnOffFocusedInbox } from '../actions/turnOffFocusedInbox';
import { logFmsActionClick } from './logFmsActionClick';
import { lazyMountAndShowFullOptions } from 'owa-options-view';
import { lazyUpdateSettingDirectly } from 'owa-proofing-option';

export function executeTurnOffFocusedInbox(requestId: string) {
    logFmsActionClick(requestId);
    turnOffFocusedInbox();
}

export function showThemeOption(requestId: string) {
    logFmsActionClick(requestId);
    lazyMountAndShowFullOptions.importAndExecute('general', 'appAppearance');
}

export function showLayoutOption(requestId: string) {
    logFmsActionClick(requestId);
    lazyMountAndShowFullOptions.importAndExecute('mail', 'layout');
}

export function showJunkEmailOption(requestId: string) {
    logFmsActionClick(requestId);
    lazyMountAndShowFullOptions.importAndExecute('mail', 'junkEmail');
}

export function turnOffTextPredictions(requestId: string) {
    logFmsActionClick(requestId);
    lazyUpdateSettingDirectly.importAndExecute('textPredictionEnabled', false);
}
